var map = {
	"./WindmereSuite/optimized/1 9.48.55 AM 9.48.55 AM.jpg": 9087,
	"./WindmereSuite/optimized/2 9.48.55 AM 9.48.55 AM.jpg": 44,
	"./WindmereSuite/optimized/Breakfast-18 9.48.54 AM.jpg": 3612,
	"./WindmereSuite/optimized/Breakfast-18 copy.jpg": 5600,
	"./WindmereSuite/optimized/Breakfast-19 9.48.55 AM 9.48.55 AM.jpg": 7914,
	"./WindmereSuite/optimized/Breakfast-4 9.48.55 AM 9.48.55 AM 9.48.55 AM.jpg": 1860,
	"./WindmereSuite/optimized/Central-Area-16.jpg": 3835,
	"./WindmereSuite/optimized/ChefPhoto 9.48.55 AM 9.48.55 AM.jpg": 4770,
	"./WindmereSuite/optimized/ColleenCobleHeader 9.48.55 AM.jpg": 4170,
	"./WindmereSuite/optimized/ColleenCobleNewestBook 9.48.55 AM.jpg": 8264,
	"./WindmereSuite/optimized/Cookie-Skillet-(1).jpg": 1072,
	"./WindmereSuite/optimized/CookieSkillet.jpg": 8384,
	"./WindmereSuite/optimized/CookiesCanvas2024Header 9.48.55 AM.jpg": 2930,
	"./WindmereSuite/optimized/CookiesCanvasHeader 9.48.55 AM.jpg": 1198,
	"./WindmereSuite/optimized/CookingClassHeader 9.48.55 AM.jpg": 2123,
	"./WindmereSuite/optimized/Garden-Room-3.jpg": 6987,
	"./WindmereSuite/optimized/Garden-Room-4.jpg": 5400,
	"./WindmereSuite/optimized/Globe-2 9.48.55 AM 9.48.55 AM.jpg": 3276,
	"./WindmereSuite/optimized/Great-Room-10.jpg": 9331,
	"./WindmereSuite/optimized/Great-Room-2.jpg": 4572,
	"./WindmereSuite/optimized/Great-Room-4.jpg": 9722,
	"./WindmereSuite/optimized/Great-Room-5.jpg": 887,
	"./WindmereSuite/optimized/Great-Room-6.jpg": 9960,
	"./WindmereSuite/optimized/Great-Room-7.jpg": 7573,
	"./WindmereSuite/optimized/Great-Room-8.jpg": 7462,
	"./WindmereSuite/optimized/HotelsCombined.jpg": 5644,
	"./WindmereSuite/optimized/Inn-At-Windmere-Christmas-Tea-(Instagram-Post-(Portrait)).jpg": 6561,
	"./WindmereSuite/optimized/Inn-At-Windmere-Christmas-Tea---Flyer.jpg": 5682,
	"./WindmereSuite/optimized/Lighthouse-Room-2.jpg": 1175,
	"./WindmereSuite/optimized/Lighthouse-Room-5.jpg": 3740,
	"./WindmereSuite/optimized/Lilac-Room-10.jpg": 6855,
	"./WindmereSuite/optimized/Lilac-Room-11.jpg": 4698,
	"./WindmereSuite/optimized/Lilac-Room-12.jpg": 5189,
	"./WindmereSuite/optimized/Lilac-Room-14.jpg": 7611,
	"./WindmereSuite/optimized/Lilac-Room-26.jpg": 2004,
	"./WindmereSuite/optimized/Lilac-Room-7.jpg": 4201,
	"./WindmereSuite/optimized/PatDelagrangeHeadshot.jpg": 8917,
	"./WindmereSuite/optimized/Piano-5 9.48.56 AM 9.48.56 AM.jpg": 5133,
	"./WindmereSuite/optimized/Reading-Nook-(1).jpg": 5791,
	"./WindmereSuite/optimized/ReadingNook.jpg": 5821,
	"./WindmereSuite/optimized/SourdoughHeader.jpg": 5313,
	"./WindmereSuite/optimized/Sunrise-Suite-(2)-(1).jpg": 3921,
	"./WindmereSuite/optimized/Sunrise-Suite-1.jpg": 390,
	"./WindmereSuite/optimized/Sunrise-Suite-10.jpg": 492,
	"./WindmereSuite/optimized/Sunrise-Suite-12.jpg": 6174,
	"./WindmereSuite/optimized/Sunrise-Suite-16.jpg": 9098,
	"./WindmereSuite/optimized/Sunrise-Suite-17.jpg": 4903,
	"./WindmereSuite/optimized/Sunrise-Suite-24.jpg": 4513,
	"./WindmereSuite/optimized/Sunrise-Suite-7.jpg": 5344,
	"./WindmereSuite/optimized/SunriseSuite.jpg": 3299,
	"./WindmereSuite/optimized/TOS 9.48.56 AM.jpg": 7271,
	"./WindmereSuite/optimized/Taste-of-Summer---Flyer-(7)-copy.jpg": 8665,
	"./WindmereSuite/optimized/Taste-of-Summer---Flyer-(7).jpg": 3491,
	"./WindmereSuite/optimized/Taste-of-Summer.jpg": 9003,
	"./WindmereSuite/optimized/TasteofSummerGraphic 9.48.56 AM.jpg": 4806,
	"./WindmereSuite/optimized/Tea-Station-37.jpg": 1100,
	"./WindmereSuite/optimized/ValentinesBanner.jpg": 4499,
	"./WindmereSuite/optimized/WebsiteBanner_2.jpg": 8352,
	"./WindmereSuite/optimized/Windmere Suite-15 copy.jpg": 3137,
	"./WindmereSuite/optimized/Windmere Suite-15.jpg": 9904,
	"./WindmereSuite/optimized/Windmere Suite-16.jpg": 7903,
	"./WindmereSuite/optimized/Windmere Suite-17.jpg": 6194,
	"./WindmereSuite/optimized/Windmere Suite-18.jpg": 4233,
	"./WindmereSuite/optimized/Windmere Suite-23.jpg": 4031,
	"./WindmereSuite/optimized/Windmere Suite-29.jpg": 5573,
	"./WindmereSuite/optimized/Windmere Suite-35.jpg": 5734,
	"./WindmereSuite/optimized/Windmere Suite-41.jpg": 4595,
	"./WindmereSuite/optimized/Windmere-DVD-Library-(2).jpg": 5092,
	"./WindmereSuite/optimized/Windmere-Suite-15 3.54.22 PM.jpg": 1313,
	"./WindmereSuite/optimized/Windmere-Suite-15.jpg": 8421,
	"./WindmereSuite/optimized/Windmere-Valentines---Website-Header-(1).jpg": 6086,
	"./WindmereSuite/optimized/WindmereChristmasTea-EmailHeader 9.48.56 AM.jpg": 9204,
	"./WindmereSuite/optimized/WindmereChristmasTea2024.jpg": 3669,
	"./WindmereSuite/optimized/WindmereDVDLibrary.jpg": 4480,
	"./WindmereSuite/optimized/Window-Seat-17.jpg": 6019,
	"./WindmereSuite/optimized/background 9.48.55 AM.jpg": 3174,
	"./WindmereSuite/optimized/christmas-tea-22 9.48.55 AM.jpg": 2700,
	"./WindmereSuite/optimized/church 9.48.55 AM.jpg": 5681,
	"./WindmereSuite/optimized/church-retreat-01 9.48.55 AM.jpg": 7779,
	"./WindmereSuite/optimized/church-retreat-02 9.48.55 AM.jpg": 1457,
	"./WindmereSuite/optimized/contact-us 9.48.55 AM 9.48.55 AM.jpg": 6189,
	"./WindmereSuite/optimized/ddIcon 9.48.55 AM.jpg": 2679,
	"./WindmereSuite/optimized/garden-room 9.48.55 AM.jpg": 5059,
	"./WindmereSuite/optimized/garden-room-01 9.48.55 AM.jpg": 5687,
	"./WindmereSuite/optimized/garden-room-01-thumb 9.48.55 AM.jpg": 7358,
	"./WindmereSuite/optimized/garden-room-02 9.48.55 AM.jpg": 7842,
	"./WindmereSuite/optimized/inn-at-windmere-front-slide-1-edit 9.48.55 AM.jpg": 6036,
	"./WindmereSuite/optimized/inn-at-windmere-gazebo-slide-3-edit 9.48.55 AM.jpg": 9107,
	"./WindmereSuite/optimized/inn-at-windmere-main-room-slide-4-edit 9.48.55 AM.jpg": 1961,
	"./WindmereSuite/optimized/inn-at-windmere-steps-slide-2-edit 9.48.55 AM.jpg": 2427,
	"./WindmereSuite/optimized/inn-at-windmere-table-slide-5-edit 9.48.55 AM.jpg": 1801,
	"./WindmereSuite/optimized/lightBackground2 9.48.55 AM 9.48.55 AM.jpg": 4130,
	"./WindmereSuite/optimized/lighthouse-room 9.48.55 AM.jpg": 4768,
	"./WindmereSuite/optimized/lighthouse-room-01 9.48.55 AM.jpg": 8242,
	"./WindmereSuite/optimized/lighthouse-room-01-thumb 9.48.55 AM.jpg": 7115,
	"./WindmereSuite/optimized/lighthouse-room-02 9.48.55 AM.jpg": 4743,
	"./WindmereSuite/optimized/lilac-room 9.48.55 AM.jpg": 5505,
	"./WindmereSuite/optimized/lilac-room-01 9.48.55 AM.jpg": 1233,
	"./WindmereSuite/optimized/lilac-room-01-thumb 9.48.55 AM.jpg": 2876,
	"./WindmereSuite/optimized/lilac-room-02 9.48.55 AM.jpg": 9000,
	"./WindmereSuite/optimized/logo 9.48.55 AM.jpg": 7793,
	"./WindmereSuite/optimized/logo5.jpg": 4728,
	"./WindmereSuite/optimized/menuIcon1.jpg": 2421,
	"./WindmereSuite/optimized/nav 9.48.56 AM 9.48.56 AM.jpg": 4067,
	"./WindmereSuite/optimized/nav1 9.48.56 AM 9.48.56 AM.jpg": 7774,
	"./WindmereSuite/optimized/pancake1.jpg": 7654,
	"./WindmereSuite/optimized/paul-and-susie-rexroth 9.48.56 AM.jpg": 4674,
	"./WindmereSuite/optimized/previousEventLine.jpg": 461,
	"./WindmereSuite/optimized/previousEventLine2.jpg": 7235,
	"./WindmereSuite/optimized/previousEventLine3.jpg": 1974,
	"./WindmereSuite/optimized/red 9.48.56 AM.jpg": 7162,
	"./WindmereSuite/optimized/red1 9.48.56 AM.jpg": 5909,
	"./WindmereSuite/optimized/red2 9.48.56 AM.jpg": 1380,
	"./WindmereSuite/optimized/scrapbooking 9.48.56 AM.jpg": 5872,
	"./WindmereSuite/optimized/scrapbooking-and-quilting-01 9.48.56 AM.jpg": 4939,
	"./WindmereSuite/optimized/scrapbooking-and-quilting-02 9.48.56 AM.jpg": 8302,
	"./WindmereSuite/optimized/sunrise-room 9.48.56 AM.jpg": 7866,
	"./WindmereSuite/optimized/sunrise-room-01 9.48.56 AM.jpg": 6558,
	"./WindmereSuite/optimized/sunrise-room-01-thumb 9.48.56 AM.jpg": 3863,
	"./WindmereSuite/optimized/sunrise-room-02 9.48.56 AM.jpg": 2155,
	"./WindmereSuite/optimized/sunrise-room-03 9.48.56 AM.jpg": 5320,
	"./WindmereSuite/optimized/windmere-suite 9.48.56 AM.jpg": 4167,
	"./WindmereSuite/optimized/windmere-suite-01 9.48.56 AM.jpg": 8889,
	"./WindmereSuite/optimized/windmere-suite-02 9.48.56 AM.jpg": 3128,
	"./WindmereSuite/optimized/windmere-suite-02-thumb 9.48.56 AM.jpg": 6013,
	"./WindmereSuite/optimized/windmere-suite-03 9.48.56 AM.jpg": 3867,
	"./WindmereSuite/optimized/windmere-suite-04 9.48.56 AM.jpg": 8666,
	"./WindmereSuite/optimized/windmere-suite-15 9.48.56 AM.jpg": 2580,
	"./WindmereSuite/optimized/windmere-suite-16 9.48.56 AM 9.48.56 AM.jpg": 68,
	"./WindmereSuite/optimized/windmere-suite-17 9.48.56 AM 9.48.56 AM.jpg": 6037,
	"./WindmereSuite/optimized/windmere-suite-18 9.48.56 AM 9.48.56 AM.jpg": 9510,
	"./WindmereSuite/optimized/windmere-suite-23 9.48.56 AM 9.48.56 AM 9.48.56 AM.jpg": 8728,
	"./WindmereSuite/optimized/windmere-suite-29 9.48.56 AM.jpg": 3719,
	"./WindmereSuite/optimized/windmere-suite-35 9.48.56 AM 9.48.56 AM.jpg": 9549,
	"./WindmereSuite/optimized/windmere-suite-41 9.48.56 AM 9.48.56 AM.jpg": 6204,
	"./WindmereSuite/windmere-suite-15.jpg": 9615,
	"./WindmereSuite/windmere-suite-16.jpg": 8304,
	"./WindmereSuite/windmere-suite-17.jpg": 1757,
	"./WindmereSuite/windmere-suite-18.jpg": 6750,
	"./WindmereSuite/windmere-suite-23.jpg": 1740,
	"./WindmereSuite/windmere-suite-29.jpg": 4630,
	"./WindmereSuite/windmere-suite-35.jpg": 8117,
	"./WindmereSuite/windmere-suite-41.jpg": 4980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4388;